import { withCompInfo } from '@wix/editor-elements-integrations'
import { VectorImageCSS, VectorImageCssVars, VectorImageDefinition } from './VectorImage'
import { getCSSDropShadow } from '@wix/thunderbolt-commons'
import { CompDataVectorImage, getVectorImageCSS } from './VectorImageHelpers'
import { mapKeys, pickBy } from 'lodash'

export const css = withCompInfo<VectorImageCssVars | {}, VectorImageDefinition>()(
	['compDesign', 'compData', 'compProps', 'hasResponsiveLayout', 'siteColors', 'styleProperties'],
	({ compDesign, compData, compProps, hasResponsiveLayout, siteColors, styleProperties }) => {
		const shadow = compDesign?.shadow
		const useCSSDropShadow = shadow && hasResponsiveLayout
		const dropShadow = useCSSDropShadow && getCSSDropShadow(shadow, siteColors)

		const resolvedSvg = (compData as CompDataVectorImage).resolvedSvg
		const vectorImageCss: VectorImageCSS =
			getVectorImageCSS({
				resolvedSvg,
				design: compDesign,
				compProps,
				styleProperties,
				siteColors,
			}) || {}

		const vars = mapKeys(vectorImageCss, (__, key) => `--${key || ''}`)

		return {
			...pickBy(vars, (__, key) => key !== '--transform'),
			...(vars['--transform'] ? { '--flip': vars['--transform'] } : {}),
			...(useCSSDropShadow ? { '--drop-shadow': dropShadow } : {}),
		} as VectorImageCssVars
	}
)
